"use client";

import { Skeleton } from "@/components/ui/feedback/skeleton";
import { cn } from "@/lib/utils";

export interface JobEntitySkeletonProps {
  density?: "comfortable" | "compact";
  className?: string;
}

export function JobEntitySkeleton({
  density = "comfortable",
  className,
}: JobEntitySkeletonProps) {
  const isCompact = density === "compact";
  return (
    <div
      className={cn(
        "relative border border-border bg-card",
        isCompact ? "p-3" : "p-3 sm:p-4",
        className,
      )}
    >
      <div className="flex items-start gap-3 sm:gap-4">
        <Skeleton
          className={cn(
            "shrink-0 border border-border",
            isCompact
              ? "h-10 w-10 sm:h-12 sm:w-12"
              : "h-14 w-14 sm:h-16 sm:w-16",
          )}
        />
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-1/3" />
          {!isCompact && <Skeleton className="hidden h-3 w-full sm:block" />}
          <div className="mt-2 flex flex-wrap gap-2">
            <Skeleton className="h-6 w-28" />
            <Skeleton className="h-6 w-24" />
            {!isCompact && <Skeleton className="h-6 w-20" />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobEntitySkeleton;
